import React, { useEffect, useState } from "react";
import { Pivot, PivotItem, Stack } from "@fluentui/react";
import "./Quotation.css";
import { QuotationList } from "./QuotationList";
import { appInsights } from "../../services/Logging/AppInsights";
import { QuotationStatus } from "./Common/QuotationData";
import { Card } from "@coherence-design-system/controls";
import { CardStyles, QuotationStackStyle } from "./QuotationStyle";

interface IQuotationProps {
  onQuotation: (isQuotation: boolean) => void;
}

export const Quotation: React.FunctionComponent<IQuotationProps> = (props: IQuotationProps) => {
  const QuotationHeading = "Quotations";
  const [quotationStatus, setQuotationStatus] = useState<string>(
    QuotationStatus.All
  );
  const [parentSearchText, setParentSearchText] = useState<string>("");

  useEffect(() => {
    props.onQuotation(true);
  }, []);
  const onStatusChange = (
    item?: PivotItem,
    event?: React.MouseEvent<HTMLElement>| React.KeyboardEvent<HTMLElement>
  ) => {
    if (item?.props.headerText) {
      appInsights.trackEvent({
        name: `In Quotation.tsx, Clicked Pivot ${item.props.headerText} to filter and show quotations of selected status.`,
      });
      setQuotationStatus(item.props.headerText);
    }
  };

  const handleSearchTextChange = (text: string) => {
    setParentSearchText(text);
  };

  return (
    <Stack
     styles={QuotationStackStyle}
    >
      <Card styles={CardStyles}>
        <h2>{QuotationHeading}</h2>
      </Card>      
    <Stack>
      <Pivot
        aria-label="All"
        onLinkClick={onStatusChange}
        styles={{ root: { marginLeft: "25px" } }}
      >
        <PivotItem headerText="All"></PivotItem>
        <PivotItem headerText="Draft"></PivotItem>
        <PivotItem headerText="Confirmed"></PivotItem>
        <PivotItem headerText="Cancelled"></PivotItem>
        <PivotItem headerText="Expired"></PivotItem>
      </Pivot>
    </Stack>
     <Stack style={{ height: "75vh", paddingLeft:'70px', paddingRight:'70px', overflowY: "hidden" }}>
        <QuotationList
          status={quotationStatus}
          searchText={parentSearchText}
          onSearchTextChange={handleSearchTextChange}
        />
      </Stack>
    </Stack>
  );
};
